import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function HomeFooter() {
  return (
    <footer className="bg-background-800 text-background-50 pt-16 md:pt-20 pb-8 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 mb-16">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="font-heading text-xl font-semibold text-background-50">
                PandaBuy Boats
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed mb-6 max-w-sm">
              Your gateway to smarter shopping. Discover curated product spreadsheets, compare prices across categories, and find the best deals — all updated weekly.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Products</h4>
            <div className="flex flex-col gap-2.5">
              {categories.slice(0, 4).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Resources</h4>
            <div className="flex flex-col gap-2.5">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                PandaBuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                All Spreadsheets
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Trending Deals
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Guides</h4>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/pandabuy-sheet-guide"
                className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                How to Use Guide
              </Link>
              <Link
                to="/"
                className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Home
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-6">
          <p className="text-xs text-background-400">
            &copy; 2026 PandaBuy Boats. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 rounded-lg border border-background-600 flex items-center justify-center text-background-400 hover:text-background-100 hover:border-background-400 transition-colors cursor-pointer"
            >
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 rounded-lg border border-background-600 flex items-center justify-center text-background-400 hover:text-background-100 hover:border-background-400 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 rounded-lg border border-background-600 flex items-center justify-center text-background-400 hover:text-background-100 hover:border-background-400 transition-colors cursor-pointer"
            >
              <i className="ri-pinterest-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-8 h-8 rounded-lg border border-background-600 flex items-center justify-center text-background-400 hover:text-background-100 hover:border-background-400 transition-colors cursor-pointer"
            >
              <i className="ri-tiktok-line text-sm"></i>
            </a>
          </div>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-background-400 hover:text-background-200 transition-colors cursor-pointer"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}